import React from "react";
import CurrencyFormat from '../../../Formatters/CurrencyFormat';
import PropTypes from 'prop-types';

export default function ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount) {
    return {
        video: {
            name: "Term vs Permanent Insurance",
            link: "https://player.vimeo.com/video/213549645",
        },
        image: "product-landing/perm/circle1.png",
        specs: [
            {
                title: "Eligibility",
                text: `${minAge} - ${maxAge} years`,
            },
            {
                title: "Coverage amount",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
            },
            {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAge}-${maxAge} are welcome to apply. (Ages 55-65 there is additional underwriting.)`,
            },
            {
                title: "Extra benefits",
                text: "Fixed premiums, No medical exam required, Instant issue underwriting policy approved in minutes, and Guaranteed interest rate: 4%, Builds tax deferred cash value",
            },
        ],
        hideNeedsAnalysis:true,
    }
}

ProductSpecificationsData.propTypes = {
    minAge: PropTypes.number.isRequired,
    maxAge: PropTypes.number.isRequired,
    minCoverageAmount: PropTypes.number.isRequired,
    maxCoverageAmount: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Perm/ProductSpecificationsData.js